function getFilename(name, url) {
	const [, basename = '', extension = ''] = url.match(/(?:^|^[^?#]*\/)([^./?#]*)(\..+?)?(?:\?|#|$)/) || [];
	if (name) {
		return !name.includes('.') && extension ? name + extension : name;
	}
	return basename + extension || 'download.jpg';
}

export async function downloadBlob(url, name) {
	const parsedUrl = new URL(url, location.href);
	if (parsedUrl.origin !== location.origin) {
		// Some urls cache the non-cors response, making the fetch fail
		parsedUrl.searchParams.set('_cors', '1');
	}
	const result = await fetch(parsedUrl.href);
	const blob = await result.blob();
	const link = document.createElement('a');
	link.href = URL.createObjectURL(blob);
	link.download = getFilename(name, url);
	link.dataset.downloadurl = ['application/octet-stream', link.download, link.href].join(':');

	document.body.append(link);
	link.click();
	link.remove();
}

const imageMimeTypes = {
	jpg: 'image/jpeg',
	png: 'image/png',
	webp: 'image/webp',
};
export async function downloadImage(src, name) {
	if (!src) return;

	let url = src;
	if (typeof src !== 'string') url = src.src;

	// Hard to feature-detect "download" working unfortunately, so we have to sniff the browser
	const agent = navigator.userAgent.toLowerCase();
	const isIOS = agent.includes('ipad') || agent.includes('iphone');

	const link = document.createElement('a');
	link.style.display = 'none';
	const filename = getFilename(name, url);
	link.download = filename;

	if (isIOS) {
		link.href = url;
		link.target = '_blank';
	} else {
		let image = src;
		let parsedUrl = new URL(url, location.href);
		if (typeof src === 'string' || (image.crossOrigin !== 'anonymous' && parsedUrl.origin !== location.origin)) {
			image = await new Promise((resolve, reject) => {
				const img = document.createElement('img');
				img.crossOrigin = 'anonymous';
				// the response from AWS is cached, so we have to alter the url to ensure the CORS headers are present
				parsedUrl.searchParams.set('_cors', '1');
				img.src = parsedUrl.href;
				img.onload = () => resolve(img);
				img.onerror = reject;
			});
		}
		const c = document.createElement('canvas');
		const context = c.getContext('2d');
		c.width = image.naturalWidth;
		c.height = image.naturalHeight;
		context.drawImage(image, 0, 0);
		const mime = imageMimeTypes[filename.split('.').pop().toLowerCase()] || 'image/jpeg';
		link.href = c.toDataURL(mime);
	}

	document.body.append(link);
	link.click();
	link.remove();
}
